import { isTimelineDays } from '@rental/domain'

/**
 * OPS-1: the span the Planning last showed on this device, so the menu's
 * "Planning" opens on it again (the address still wins when it names one, so a
 * link or Back shows what it says). A number of days only, validated on the
 * way back as on the way in; storage that refuses or holds nonsense means
 * "the default", as on a new device (the `lock-recents.ts` pattern).
 */
const KEY = 'rental.staff.timeline-days'

/** The days this device last showed, or null when it remembers none it may show. */
export function readTimelineDays(
  storage: Pick<Storage, 'getItem'> | null = localStore(),
): number | null {
  try {
    const value: unknown = JSON.parse(storage?.getItem(KEY) ?? 'null')
    return isTimelineDays(value) ? value : null
  } catch {
    return null
  }
}

/** The counter chose a span: the next opening starts on it. */
export function rememberTimelineDays(
  days: number,
  storage: Pick<Storage, 'setItem'> | null = localStore(),
) {
  if (!isTimelineDays(days)) return
  try {
    storage?.setItem(KEY, JSON.stringify(days))
  } catch {
    // Storage refused: the next opening shows the default, as on a new device.
  }
}

function localStore(): Storage | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}
